import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { IconButton, Stack, useTheme } from '@mui/material';

import { Generatik, LogoContainer } from '@/app/ui/SideMenu/styled';
import { ReactComponent as SidebarExpandIcon } from '@/assets/icons/layout-right.svg';
import { ReactComponent as Logo } from '@/assets/logo.svg';
import { ROUTES } from '@/config/routes';

interface Props {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  isGuest?: boolean;
  disableLogoNav?: boolean;
}

const SideMenuLogo: FC<Props> = ({ isExpanded, setIsExpanded, isGuest, disableLogoNav }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <LogoContainer isExpanded={isExpanded}>
      <Stack
        sx={{ width: '100%' }}
        onClick={
          !isGuest && !disableLogoNav ? () => navigate(ROUTES.AUTHORIZED.LANDING) : undefined
        }
      >
        <Logo
          color={theme.palette.accent.main}
          style={{
            fontSize: '1.75rem',
            width: '1.75rem',
            height: '1.7rem',
            marginLeft: '0.125rem',
          }}
        />
        <Generatik isExpanded={isExpanded} />
      </Stack>

      {!isGuest && (
        <IconButton
          sx={{ padding: '0.25rem', color: theme.palette.grey[700] }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <SidebarExpandIcon />
        </IconButton>
      )}
    </LogoContainer>
  );
};

export default SideMenuLogo;
